// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-section-title {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}
.form-section-title mat-icon {
  margin-right: 8px;
  color: var(--ion-color-secondary-contrast);
}

.table-responsive {
  overflow-x: auto;
}

table {
  width: 100%;
}

th {
  background: #f5f5f5;
  font-weight: bold;
}

.success {
  color: green;
  font-weight: bold;
}

.failed {
  color: red;
  font-weight: bold;
}

mat-paginator {
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/views/main/superadmin/users/containers/user-access-log/user-access-log.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AACF;AACE;EACE,iBAAA;EACA,0CAAA;AACJ;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,mBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,YAAA;EACA,iBAAA;AAAF;;AAGA;EACE,UAAA;EACA,iBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF","sourcesContent":[".form-section-title {\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #333;\n\n  mat-icon {\n    margin-right: 8px;\n    color: var(--ion-color-secondary-contrast);\n  }\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\ntable {\n  width: 100%;\n}\n\nth {\n  background: #f5f5f5;\n  font-weight: bold;\n}\n\n.success {\n  color: green;\n  font-weight: bold;\n}\n\n.failed {\n  color: red;\n  font-weight: bold;\n}\n\nmat-paginator {\n  margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
